import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectPolicyLogs = () => createSelector(substate, (contextState) => contextState.policyLogs);
